import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CutSheet from "./cutSheets";
import Modal from "common/modal";
import InputField from "common/customInputField";
import CutMeasurements from "./cutMeasurements";
import Button from "react-bootstrap/Button";
import areaPerimeterIcon from "svg/areaPerimeter.svg";
import productsIcon from "svg/products.svg";
import editIcon from "svg/edit_blue.svg";
import imagePlaceHolder from "svg/imagePlaceholder.svg";
import { useParams } from "react-router-dom";
import { updateRoom, getSiteDetails, submitCreateNewSite } from "store/siteRepo/actionCreator";
import uniqBy from "lodash/uniqBy";
import { toast } from "react-toastify";

const RoomView = ({ project, territoryAccess }) => {
  const { siteId } = useParams();
  const dispatch = useDispatch();
  const { sub } = useSelector((state) => state.loggedInUser);
  const { viewSite } = useSelector((state) => state.siteRepo);
  const [isShowEditRoomModal, setIsShowEditRoomModal] = useState(false);
  const [updateRoomData, setUpdateRoomData] = useState({});
  const [pictureData, setPictureData] = useState();
  const [isShowFloormapModal, setIsShowFloormapModal] = useState(false);
  const [isShowEditFloorDetails, setIsShowEditFloorDetails] = useState(false);
  const [editFloorDetailsData, setEditFloorDetailsData] = useState();
  const [isUpdatingRoom, setIsUpdatingRoom] = useState(false);
  const [isUpdatingFloorDetails, setIsUpdatingFloorDetails] = useState(false);

  const products = project.layerInfoList.flatMap((layer) => layer.rooms).flatMap((room) => room.products);
  const uniqProducts = uniqBy(products, "id");
  const cutSheetData = project.cutSheetData ?? [];

  const onEditRoomFieldsChange = (e) => {
    const { id, value } = e.target;
    setUpdateRoomData({ ...updateRoomData, [id]: value });
  };

  const handleShowUpdateRoomModal = (isShow, roomData) => {
    setIsShowEditRoomModal(isShow);
    if (isShow) {
      setUpdateRoomData({ ...roomData, roomName: roomData.name });
    } else {
      setUpdateRoomData({});
    }
  };

  const confirmUpdateRoom = () => {
    if (isUpdatingRoom) {
      return;
    }
    const { roomName, layerId, roomId } = updateRoomData;
    const updateRoomReqObj = {
      roomName,
      layerId,
      roomId,
      siteId,
      updatedBy: sub,
    };
    setIsUpdatingRoom(true);

    toast
      .promise(dispatch(updateRoom(updateRoomReqObj, siteId)), {
        pending: "Updating Room",
        success: "Room updated successfully",
        error: "Could not update room, please try again.",
      })
      .then(() => {
        handleShowUpdateRoomModal(false);
      })
      .catch(() => {
        handleShowUpdateRoomModal(false);
      })
      .finally(() => setIsUpdatingRoom(false));
  };

  const handleFloormapModal = (isShow, pictureData, name) => {
    if (isShow) {
      setIsShowFloormapModal(true);
      setPictureData({ data: pictureData, name });
    } else {
      setIsShowFloormapModal(false);
    }
  };

  const handleEditFloorDataFieldsChange = (e) => {
    const { id, value } = e.target;
    setEditFloorDetailsData({ ...editFloorDetailsData, [id]: value });
  };

  const handleFloorDetailsModal = (isShow, name, layerId) => {
    setIsShowEditFloorDetails(isShow);
    if (isShow) {
      setEditFloorDetailsData({ floorName: name, layerId: layerId });
    } else {
      setEditFloorDetailsData({});
    }
  };

  const confirmEditFloorDetails = () => {
    const {
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      projectDetailsList,
    } = viewSite;
    const editFloorDetailsReqObj = {
      siteId,
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      updatedBy: sub,
      projectDetailsList: projectDetailsList?.length
        ? projectDetailsList
            .filter((projectItem) => projectItem.mprojectId === project.mprojectId)
            .map((filteredProjectItem) => {
              const {
                projectId,
                layerInfoList,
                mprojectId,
                creatorM2Id,
                isArchived,
                lastUpdatedOn,
                ownerM2Id,
                revision,
                usedM2Id,
                size,
                name,
              } = filteredProjectItem;
              return {
                mprojectId,
                projectId,
                updateType: "old",
                name,
                updatedBy: sub,
                creatorM2Id,
                isArchived,
                lastUpdatedOn,
                ownerM2Id,
                revision,
                usedM2Id,
                size,
                updatedBy: sub,
                layerInfoList: layerInfoList?.length
                  ? layerInfoList
                      .filter((layerItem) => layerItem.layerId === editFloorDetailsData.layerId)
                      .map((filteredLayerItem) => {
                        return {
                          layerId: filteredLayerItem.layerId,
                          name: editFloorDetailsData.floorName,
                          mprojectId: filteredProjectItem.mprojectId,
                          projectName: name,
                          rooms: [],
                          updatedBy: sub,
                        };
                      })
                  : [],
              };
            })
        : [],
    };

    if (isUpdatingFloorDetails) {
      return;
    }
    setIsUpdatingFloorDetails(true);

    toast
      .promise(dispatch(submitCreateNewSite(editFloorDetailsReqObj)), {
        pending: "Updating Floor Name",
        success: "Floor name updated successfully",
        error: "Could not update floor name, please try again.",
      })
      .then((res) => {
        handleFloorDetailsModal(false);
        dispatch(getSiteDetails(res.siteId));
      })
      .catch(() => {})
      .finally(() => setIsUpdatingFloorDetails(false));
  };

  return (
    <>
      <div className="accordion-items-container">
        <div className="col-12 accordion accordion-flush" id="project_room_view-accordion-parent">
          {project.layerInfoList.map((layer, index) => (
            <div className="accordion-item" key={index}>
              <div className="accordion-row d-flex align-items-start align-items-md-center flex-column flex-md-row">
                <div className="col-auto layer-image-container">
                  <img
                    src={layer.pictureData ? layer.pictureData : imagePlaceHolder}
                    alt="..."
                    className="layer-image"
                    onClick={() =>
                      layer.pictureData ? handleFloormapModal(true, layer.pictureData, layer.name) : true
                    }
                  />
                </div>

                <div className="d-flex justify-content-between col-10">
                  <div className="d-flex align-items-center">
                    <span className="item-label-header">Floor Name:</span>
                    <span className="item-label-main item-label-header">{layer.name}</span>
                    {territoryAccess && (
                      <span>
                        <img
                          src={editIcon}
                          className="edit-floor"
                          alt="..."
                          onClick={() => handleFloorDetailsModal(true, layer.name, layer.layerId)}
                        />
                      </span>
                    )}
                  </div>
                </div>

                <div className="d-flex d-md-none flex-column col-12 mt-3">
                  <div className="d-flex col-12 room-parent align-items-center justify-content-between mx-0 mb-3">
                    <div className="">
                      <span className="item-label col-9 mx-0">{layer.name}</span>
                    </div>
                  </div>
                </div>

                <div className="item justify-content-end expand d-none d-md-flex flex-grow-1">
                  <Button
                    className="accordion-button collapsed"
                    variant="link"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse-${layer.layerId}-${index}`}
                    aria-expanded="false"
                    aria-controls={`flush-collapse-${layer.layerId}-${index}`}
                    onClick={() => true}
                  ></Button>
                </div>
              </div>
              <div
                id={`flush-collapse-${layer.layerId}-${index}`}
                className="accordion-content-container accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#search-mq-results-accordion-parent"
              >
                <div className="d-flex flex-wrap product-container">
                  <div className="col-12 accordion accordion-flush" id="search-mq-results-accordion-parent">
                    {layer.rooms?.length > 0 ? (
                      layer.rooms.map((room, index) => (
                        <div className="accordion-item" key={index}>
                          <div className="accordion-row d-flex justify-content-between">
                            <div className="d-flex align-items-center" style={{ flexGrow: 2 }}>
                              <span className="room-name">{room.name}</span>
                            </div>
                            <div className="d-flex align-items-center" style={{ flexGrow: 1 }}>
                              <div
                                className="d-flex align-items-center"
                                style={{ paddingLeft: "24px", borderLeft: "1px solid #d1d1d1", height: "24px" }}
                              >
                                <img src={areaPerimeterIcon} alt="..." className="icon" />
                                <span className="item-label">Net Area</span>
                                {room.area ? room.area : "NA"}
                              </div>
                            </div>
                            <div className="d-flex room-parent align-items-center" style={{ flexGrow: 1 }}>
                              <img src={areaPerimeterIcon} alt="..." className="icon" />
                              <span className="item-label">Room Perimeter</span>
                              {room.perimeter ? room.perimeter : "NA"}
                            </div>
                            <div className="d-flex room-parent align-items-center" style={{ flexGrow: 1 }}>
                              <img src={productsIcon} alt="..." className="icon" />
                              <span className="item-label">Products Assigned</span>
                              {room.products?.length}
                            </div>
                            <div className="d-flex justify-content-end align-items-center expand item">
                              {territoryAccess && (
                                <Button
                                  className="mb-1"
                                  variant="link"
                                  onClick={() => handleShowUpdateRoomModal(true, { ...room })}
                                >
                                  <img src={editIcon} alt="..." />
                                </Button>
                              )}
                              <Button
                                className="accordion-button collapsed"
                                variant="link"
                                data-bs-toggle="collapse"
                                data-bs-target={`#flush-collapse-${room.roomId}-${index}`}
                                aria-expanded="false"
                                aria-controls={`flush-collapse-${room.roomId}-${index}`}
                                onClick={() => true}
                              ></Button>
                            </div>
                          </div>

                          <div
                            id={`flush-collapse-${room.roomId}-${index}`}
                            className="accordion-content-container accordion-collapse collapse"
                            aria-labelledby="flush-headingOne"
                            data-bs-parent="#search-mq-results-accordion-parent"
                          >
                            <div className="d-flex flex-wrap product-container">
                              {room.products && room.products.length > 0 ? (
                                room.products.map((product, prdIdx) => (
                                  <div className="product-card col-11 col-md-5 col-lg-3" key={prdIdx}>
                                    <div className="product-card__heading-container align-items-center">
                                      <div className="d-flex align-items-center overflow-hidden">
                                        <img src={productsIcon} alt="..." className="product-icon" />
                                        <span className="product-card__product-name">{product.id}</span>
                                      </div>
                                    </div>
                                    <div className="product-card__seperator" />
                                    <div className="product-card__body flex-column">
                                      <div className="d-flex flex-row justify-content-between mb-4">
                                        <span className="product-attr-label">Type</span>
                                        <span>{product.type ? product.type : "NA"}</span>
                                      </div>
                                      <div className="d-flex flex-row justify-content-between">
                                        <span className="product-attr-label">Amount</span>
                                        <span>{product.quantity ? product.quantity : "NA"}</span>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="d-flex w-100 align-items-center justify-content-center">
                                  <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                                    No products available in this room. Consider adding one!
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="d-flex w-100 align-items-center justify-content-center">
                        <div className="alert alert-warning no-rooms-info" role="alert">
                          No rooms available in this floor. Consider adding one!
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {cutSheetData?.length ? (
          <div className="container-fluid search-form-container cutsheets-container">
            <div className="search-form-container__title d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <span className="search-form-container__title--text">Cut Sheets</span>
              </div>
            </div>
            <div className="d-flex flex-wrap">
              {cutSheetData?.map((cutsheetItem) => {
                if (cutsheetItem.cutSheetImage) {
                  return (
                    <CutSheet
                      productName={cutsheetItem.productName}
                      image={`data:image/jpeg;base64,${cutsheetItem.cutSheetImage}`}
                    />
                  );
                }
              })}
            </div>
          </div>
        ) : (
          ""
        )}
        {cutSheetData?.length ? (
          <CutMeasurements cutSheetData={cutSheetData} productsData={uniqProducts} projectId={project.projectId} />
        ) : (
          ""
        )}
      </div>
      {isShowEditRoomModal && (
        <Modal
          title={"Edit Room"}
          handleSave={confirmUpdateRoom}
          handleCancel={() => handleShowUpdateRoomModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Save"}
          isSaveBtnDisabled={isUpdatingRoom}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form className="search-form-container__fields__form">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="roomName"
                        label="Room Name"
                        placeholder={"Enter Room Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={updateRoomData.roomName || ""}
                        onChange={(e) => onEditRoomFieldsChange(e)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}
      {isShowFloormapModal && (
        <Modal
          title={pictureData.name}
          handleSave={() => {}}
          handleCancel={() => handleFloormapModal(false)}
          size={"lg"}
          sectionName={""}
          bodyClass={"account-lookup-search-form"}
        >
          <>
            <img src={pictureData.data} alt="..." className="col-12 px-1 px-md-2" />
          </>
        </Modal>
      )}

      {isShowEditFloorDetails && (
        <Modal
          title={"Edit Floor Name"}
          handleSave={confirmEditFloorDetails}
          handleCancel={() => handleFloorDetailsModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Save"}
          isSaveBtnDisabled={isUpdatingFloorDetails}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form className="search-form-container__fields__form">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="floorName"
                        label="Floor Name"
                        placeholder={"Enter Floor Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={editFloorDetailsData.floorName || ""}
                        onChange={(e) => handleEditFloorDataFieldsChange(e)}
                        disabled={false}
                        isRequired={false}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}
    </>
  );
};

export default RoomView;
